import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

export const createTypesensePartSearchAdapter = (mobileConfigs: any) => {
  try {
    console.log(
      "createTypesensePartSearchAdapter mobileConfigs:",
      mobileConfigs,
    );
    if (!mobileConfigs?.typesense_host || !mobileConfigs?.typesense_api_key) {
      console.log("Typesense config missing!");
      return null;
    }
    return new TypesenseInstantSearchAdapter({
      server: {
        nodes: [
          {
            host: mobileConfigs.typesense_host,
            port: 443,
            protocol: "https",
          },
        ],
        apiKey: mobileConfigs.typesense_api_key,
      },
      additionalSearchParameters: {
        query_by: "partName,partNumber",
      },
    });
  } catch (error) {
    console.error("Failed to create Typesense adapter:", error);
    return null;
  }
};

export const mapTypesenseHitToBackendFormat = (part: any) => {
  try {
    console.log(part);
    return {
      ...part,
      _id: part._id || part.partId,
    };
  } catch (error) {
    console.error("Failed to map Typesense hit:", error);
    return part;
  }
};

export const searchPartsInTypesense = async (
  typesenseAdapter: any,
  partNumber: string,
  page: number = 1,
  limit: number = 20,
) => {
  try {
    const results = await typesenseAdapter.searchClient.search([
      {
        indexName: "partmasters",
        params: {
          query: partNumber.trim(),
          hitsPerPage: limit,
          page: page - 1,
        },
      },
    ] as any);
    console.log("results", results);

    return (results as any).results[0]?.hits || [];
  } catch (error) {
    console.error("Typesense search failed:", error);
    return [];
  }
};

export const performPartSearchStrategy = async (
  partNumber: string,
  context: {
    typesenseAdapter: any;
    backendSearch: (partNumber: string) => Promise<any>;
    page?: number;
    limit?: number;
  },
) => {
  const trimmedPartNumber = partNumber.trim();
  if (trimmedPartNumber === "") return [];
  const page = context.page || 1;
  const limit = context.limit || 20;

  // Strategy 1: Typesense
  try {
    console.log(
      "Strategy 1: context.typesenseAdapter exists?",
      !!context.typesenseAdapter,
    );
    if (context.typesenseAdapter) {
      console.log("Calling searchPartsInTypesense for:", trimmedPartNumber);
      const hits = await searchPartsInTypesense(
        context.typesenseAdapter,
        trimmedPartNumber,
        page,
        limit,
      );
      if (hits && hits.length > 0) {
        return hits.map((hit: any) => mapTypesenseHitToBackendFormat(hit));
      }
    }
  } catch (error) {
    console.error("Strategy 1 (Typesense) failed:", error);
  }

  // Strategy 2: Backend Fallback (Only on page 1)
  if (page === 1) {
    try {
      return (await context.backendSearch(trimmedPartNumber)) || [];
    } catch (error) {
      console.error("Strategy 2 (Backend) failed:", error);
      return [];
    }
  }

  return [];
};
